import { Divider, Grid } from "@mui/material";
import React, { useEffect } from "react";
import Header from "../Header/Header1";
import Footernew from "../Footer/Footernew";
import "./Withdraw.scss";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
  Modal,
  FormControl,
  MenuItem,
  Select,
  Typography,
  Tabs,
  useMediaQuery,
  useTheme,
  InputAdornment,
} from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import { toast } from "react-hot-toast";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import Loader from "../Loader";
import PropTypes from "prop-types";
import coins from "../../Img/coins/coin.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import noodata from "../../Img/no-data.svg";
import btc from "../../Img/btc.svg";
import ltc from "../../Img/ltc.svg";
// import Dreamster-Exchange from "../../Img/Dreamster-Exchange.svg";
import kcs from "../../Img/kcs.svg";
import processing from "../../Img/processing.svg";
import tic_mark from "../../Img/tic_mark.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import SideBar from "../SideBar/SideBar";
import usercalls from "../../Axios";
import consts from "../../constant";
import { getTimeFormat } from "../../Helpers/DateAndTime";
import { useUserData } from "../../Contexts/UserContext";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  // border: "2px solid #000",
  borderRadius: "10px",
  // boxShadow: 24,
  p: 2,
};

//   {
//     date: "14.25pm",
//     currency: coins,
//     currencyName: "Dreamster-Exchange",
//     assetType: "Spot Asset",
//     address: "745689123",
//     amount: "35.15",
//     txid: "54689234",
//     status: "Verified!",
//     action: (
//       <svg
//         width="23"
//         height="16"
//         viewBox="0 0 23 16"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M11.0625 0.5C6.0625 0.5 1.7925 3.61 0.0625 8C1.7925 12.39 6.0625 15.5 11.0625 15.5C16.0625 15.5 20.3325 12.39 22.0625 8C20.3325 3.61 16.0625 0.5 11.0625 0.5ZM11.0625 13C8.3025 13 6.0625 10.76 6.0625 8C6.0625 5.24 8.3025 3 11.0625 3C13.8225 3 16.0625 5.24 16.0625 8C16.0625 10.76 13.8225 13 11.0625 13ZM11.0625 5C9.4025 5 8.0625 6.34 8.0625 8C8.0625 9.66 9.4025 11 11.0625 11C12.7225 11 14.0625 9.66 14.0625 8C14.0625 6.34 12.7225 5 11.0625 5Z"
//           fill="#566FFF"
//         />
//       </svg>
//     ),
//   },
//   {
//     date: "14.25pm",
//     currency: coins,
//     currencyName: "Dreamster-Exchange",
//     assetType: "Referral Asset",
//     address: "745689123",
//     amount: "35.15",
//     txid: "54689234",
//     status: "Verified!",
//     action: (
//       <svg
//         width="23"
//         height="16"
//         viewBox="0 0 23 16"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M11.0625 0.5C6.0625 0.5 1.7925 3.61 0.0625 8C1.7925 12.39 6.0625 15.5 11.0625 15.5C16.0625 15.5 20.3325 12.39 22.0625 8C20.3325 3.61 16.0625 0.5 11.0625 0.5ZM11.0625 13C8.3025 13 6.0625 10.76 6.0625 8C6.0625 5.24 8.3025 3 11.0625 3C13.8225 3 16.0625 5.24 16.0625 8C16.0625 10.76 13.8225 13 11.0625 13ZM11.0625 5C9.4025 5 8.0625 6.34 8.0625 8C8.0625 9.66 9.4025 11 11.0625 11C12.7225 11 14.0625 9.66 14.0625 8C14.0625 6.34 12.7225 5 11.0625 5Z"
//           fill="#566FFF"
//         />
//       </svg>
//     ),
//   },
//   {
//     date: "14.25pm",
//     currency: coins,
//     currencyName: "Dreamster-Exchange",
//     assetType: "Reward Asset",
//     address: "745689123",
//     amount: "35.15",
//     txid: "54689234",
//     status: "Verified!",
//     action: (
//       <svg
//         width="23"
//         height="16"
//         viewBox="0 0 23 16"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M11.0625 0.5C6.0625 0.5 1.7925 3.61 0.0625 8C1.7925 12.39 6.0625 15.5 11.0625 15.5C16.0625 15.5 20.3325 12.39 22.0625 8C20.3325 3.61 16.0625 0.5 11.0625 0.5ZM11.0625 13C8.3025 13 6.0625 10.76 6.0625 8C6.0625 5.24 8.3025 3 11.0625 3C13.8225 3 16.0625 5.24 16.0625 8C16.0625 10.76 13.8225 13 11.0625 13ZM11.0625 5C9.4025 5 8.0625 6.34 8.0625 8C8.0625 9.66 9.4025 11 11.0625 11C12.7225 11 14.0625 9.66 14.0625 8C14.0625 6.34 12.7225 5 11.0625 5Z"
//           fill="#566FFF"
//         />
//       </svg>
//     ),
//   },
//   {
//     date: "14.25pm",
//     currency: coins,
//     currencyName: "Dreamster-Exchange",
//     assetType: "Reward Asset",
//     address: "745689123",
//     amount: "35.15",
//     txid: "54689234",
//     status: "Verified!",
//     action: (
//       <svg
//         width="23"
//         height="16"
//         viewBox="0 0 23 16"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M11.0625 0.5C6.0625 0.5 1.7925 3.61 0.0625 8C1.7925 12.39 6.0625 15.5 11.0625 15.5C16.0625 15.5 20.3325 12.39 22.0625 8C20.3325 3.61 16.0625 0.5 11.0625 0.5ZM11.0625 13C8.3025 13 6.0625 10.76 6.0625 8C6.0625 5.24 8.3025 3 11.0625 3C13.8225 3 16.0625 5.24 16.0625 8C16.0625 10.76 13.8225 13 11.0625 13ZM11.0625 5C9.4025 5 8.0625 6.34 8.0625 8C8.0625 9.66 9.4025 11 11.0625 11C12.7225 11 14.0625 9.66 14.0625 8C14.0625 6.34 12.7225 5 11.0625 5Z"
//           fill="#566FFF"
//         />
//       </svg>
//     ),
//   },
//   {
//     date: "14.25pm",
//     currency: coins,
//     currencyName: "Dreamster-Exchange",
//     assetType: "Referral Asset",
//     address: "745689123",
//     amount: "35.15",
//     txid: "54689234",
//     status: "Verified!",
//     action: (
//       <svg
//         width="23"
//         height="16"
//         viewBox="0 0 23 16"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M11.0625 0.5C6.0625 0.5 1.7925 3.61 0.0625 8C1.7925 12.39 6.0625 15.5 11.0625 15.5C16.0625 15.5 20.3325 12.39 22.0625 8C20.3325 3.61 16.0625 0.5 11.0625 0.5ZM11.0625 13C8.3025 13 6.0625 10.76 6.0625 8C6.0625 5.24 8.3025 3 11.0625 3C13.8225 3 16.0625 5.24 16.0625 8C16.0625 10.76 13.8225 13 11.0625 13ZM11.0625 5C9.4025 5 8.0625 6.34 8.0625 8C8.0625 9.66 9.4025 11 11.0625 11C12.7225 11 14.0625 9.66 14.0625 8C14.0625 6.34 12.7225 5 11.0625 5Z"
//           fill="#566FFF"
//         />
//       </svg>
//     ),
//   },
// ];
const Withdraw = () => {
  const [value, setValue] = useState(0);

  const { userData } = useUserData();

  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const navigate = useNavigate();
  const location = useLocation();
  const symbol = location?.state;

  const [network, setNetwork] = useState("10");
  const handleChangeNetwork = (event) => {
    setNetwork(event.target.value);
  };

  const [selectedAsset, setSelectedAsset] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [withdrawAmount, setWithdrawAmount] = useState(0);

  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  //model
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [depositSelNew, setDepositSelNew] = useState("Select Coin");
  const [selectNetworkNew, setSelectNetworkNew] = useState("Select Network");
  const [symbolSearch, setSymbolSearch] = useState("");

  const [openNetwork, setOpenNetwork] = useState(false);

  const handleOpenNetwork = () => {
    if (selectedAsset === "") {
      return toast.error("Please Select Coin");
    } else {
      setOpenNetwork(true);
    }
  };

  const handleCloseNetwork = () => setOpenNetwork(false);

  const path = usercalls();

  const [history, setHistory] = useState({});
  const [assetsList, setAssetsList] = useState([]);

  const [wallet, setWallet] = useState({});
  const [withdraw, setWithdraw] = useState("");
  const handleWithdrawChange = (e) => {
    setWithdraw(e.target.value);
  };

  const [load, setLoad] = useState(false);
  const [coin, setCoin] = useState("Select Coin");

  // console.log(coin, "Coin");

  const handleChangeCoin = (event) => {
    setCoin(event.target.value);
  };

  const [asset, setAsset] = useState("cs");
  const handleChangeAsset = (event) => {
    setAsset(event.target.value);
  };
  const [Bank, setBank] = useState("sbi");
  const handleChangeBank = (event) => {
    setBank(event.target.value);
  };

  const filteredData = history?.docs?.filter((row) => {
    const matchesSearch = row?.Coinname?.toLowerCase()?.includes(
      searchTerm?.toLowerCase()
    );
    const hasBalance = hideZero ? row?.availableBalance > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [activeStep, setActiveStep] = useState(1);

  const handleNext = () => {
    var next = false;
    if (activeStep == 0) {
      if (!selectedAsset) {
        return toast.error("Please Select Currency");
      } else {
        next = true;
      }
    } else if (activeStep == 1) {
      if (!selectedNetwork) {
        return toast.error("Please Select Network");
      } else {
        next = true;
      }
    } else if (activeStep == 2) {
      if (!withdraw) {
        return toast.error("Please Enter Withdraw Address");
      } else {
        next = true;
      }
    } else if (activeStep == 3) {
      if (!withdrawAmount) {
        return toast.error("Please Enter Withdraw Amount");
      } else {
        // next = true
        navigate("/assets");
      }
    }
    if (next) {
      setActiveStep((prevActiveStep) => {
        return prevActiveStep + 1;
      });
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleMaxClick = () => {
    setWithdrawAmount(wallet?.first?.funding_balance);
  };

  function decimal(num, decimals = 12) {
    num = Number(num);
    return Number(
      (+num?.toFixed(decimals))
        ?.toString()
        ?.replace(/(\.\d*?[1-9])0+$/g, "$1")
        ?.replace(/\.0+$/, "")
    );
  }

  const data = [
    // { currencyName: "Dreamster-Exchange", icon: Dreamster-Exchange },
    { currencyName: "BTC", icon: btc },
    { currencyName: "LTC", icon: ltc },
    { currencyName: "KCS", icon: kcs },
  ];

  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => {
    // setOpen2(true);
    handleWithdrawal();
    handleClose1();
  };
  const handleClose2 = () => setOpen2(false);

  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => {
    setOpen3(false);
    setWithdraw("");
    setWithdrawAmount(0);
    setNetwork("10");
    setSelectedNetwork("");
    setActiveStep(0);
    getHistory();
  };

  const getAssets = async () => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/assets?type=withdraw`;
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      if (result?.result?.length > 0) {
        setAssetsList(result?.result);
        if (symbol?.symbol) {
          for (let i = 0; i < result?.result?.length; i++) {
            const element = result?.result[i];
            if (element?.symbol == symbol?.symbol) {
              setSelectedAsset(element);
              setCoin(element?.symbol);
              setLoad(false);
            }
          }
          setLoad(false);
        }
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  const getOwnWallet = async () => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/wallet/OwnWalletGetID`;
      const payload = {
        pair: coin ? coin : symbol?.symbol ? symbol?.symbol : "USDT",
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setWallet(result?.result);
        // if (symbol?.symbol) {
        //   for (let i = 0; i < result?.result?.length; i++) {
        //     const element = result?.result[i];
        //     if (element?.symbol == symbol?.symbol) {
        //       setSelectedAsset(element)
        //       setCoin(element?.symbol)
        //     }
        //   }
        // }
        setLoad(false);
      } else {
        setWallet({});
        setLoad(false);
      }
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  const getHistory = async () => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/WithdrawList?page=${page}&limit=${rowsPerPage}`;
      const response = await path.postCall({ url });
      const result = await response.json();
      // console.log(result, "result");
      if (result?.success == true) {
        setHistory(result?.result);
        // setHistoryTotal(result?.result?.totalDocs)
        setLoad(false);
      } else {
        setHistory({});
        // setHistoryTotal(0)
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  const handleWithdrawal = async () => {
    try {
      setLoad(true);
      // console.log(coin);
      const url = `${consts.BackendUrl}/WithDraw`;
      const payload = {
        Coinname: coin,
        Amount: withdrawAmount,
        Address: withdraw,
        Network: selectedNetwork?.Network_symbol,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      // handleClose3();
      if (result?.success) {
        getOwnWallet();
        handleOpen3();
        getHistory();
        setLoad(false);
      } else {
        toast.error(result?.message);
        // setLoad(false);
      }
    } catch (error) {
      toast.error("Error while withdrawal");
      setLoad(false);
    }
  };

  useEffect(() => {
    getAssets();
  }, []);

  useEffect(() => {
    getOwnWallet();
  }, [selectedNetwork]);

  useEffect(() => {
    getHistory();
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (userData?.kyc_verify == "false") {
      navigate("/kycverify");
      toast.error("Verify KYC to Withdraw");
    }
  }, [userData]);

  return (
    <div className="deposit-full menu-responsive">
      <Header />
      {load && <Loader />}
      <div className="main_flx">
        <SideBar />
        <div className="split_half">
          <div className="deposit-top block-top-padding">
            <div>
              <Box sx={{ width: "100%" }}>
                <Box>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="deposit-tab"
                  >
                    <Tab label="Withdraw Crypto" {...a11yProps(0)} />
                    {/* <Tab label="Withdraw INR" {...a11yProps(1)} /> */}
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <div
                        className="bord-li common-box"
                        style={{ borderRadius: "16px" }}
                      >
                        <Stepper
                          activeStep={0}
                          orientation="vertical"
                          className="deposit-stepper"
                        >
                          <Step className="deposit-steps">
                            <StepLabel>
                              <h3>Select Coin </h3>
                            </StepLabel>
                            <StepContent TransitionProps={{ in: true }}>
                              <div
                                className={
                                  md
                                    ? "d-flex gap-10"
                                    : " d-flex gap-10 flex-wrap"
                                }
                                style={{ alignItems: "flex-start" }}
                              >
                                <div style={{ width: !md ? "100%" : "100%" }}>
                                  <div className="deposit-select">
                                    <div
                                      className="display-2 sel-new cursor"
                                      onClick={() => handleOpen()}
                                    >
                                      {selectedAsset ? (
                                        <div className="display-1  ">
                                          <div className="d-flex drop-img">
                                            <img
                                              alt="btc"
                                              src={selectedAsset?.image}
                                            />
                                          </div>
                                          <div>{selectedAsset?.symbol}</div>
                                        </div>
                                      ) : (
                                        coin
                                      )}

                                      <KeyboardArrowDownIcon
                                        sx={{ fill: "var(--clr-font)" }}
                                      />
                                    </div>
                                    {/* <FormControl fullWidth>
                                      <Select
                                        className="bord-li"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={coin}
                                        onChange={handleChangeCoin}
                                        sx={{
                                          "& .MuiInputBase-formControl": {
                                            border: "0px",
                                          },
                                          "& fieldset": {
                                            border:
                                              "0px solid #d3d1d1 !important",
                                          },
                                        }}
                                      >
                                        <MenuItem
                                          value="sc"
                                          onClick={() => setSelectedAsset("")}
                                        >
                                          Select Currency
                                        </MenuItem>
                                        {assetsList?.length > 0 &&
                                          assetsList?.map((row, index) => {
                                            return (
                                              <MenuItem
                                                value={row?.symbol}
                                                key={index}
                                                onClick={() =>
                                                  setSelectedAsset(row)
                                                }
                                              >
                                                <div className="display-1">
                                                  <div className="d-flex drop-img">
                                                    <img
                                                      alt="btc"
                                                      src={`${row?.image}`}
                                                    />
                                                  </div>
                                                  <div>{row?.symbol} </div>
                                                </div>
                                              </MenuItem>
                                            );
                                          })}
                                      </Select>
                                    </FormControl> */}
                                  </div>
                                </div>
                              </div>
                              {/* <Box sx={{ mb: 2 }}>
                                <Button
                                  variant="contained"
                                  onClick={handleNext}
                                  sx={{ mt: 1, mr: 1 }}
                                  className="continue-btn"
                                >
                                  Continue
                                </Button>
                              </Box> */}
                            </StepContent>
                          </Step>
                          <Step className="deposit-steps">
                            <StepLabel>
                              <h3>Wallet Address</h3>
                            </StepLabel>
                            <StepContent TransitionProps={{ in: true }}>
                              <div className="deposit-select">
                                <div className="deposit-select widthdraw-aa ">
                                  <TextField
                                    className="bord-li"
                                    placeholder="Enter Wallet address"
                                    fullWidth
                                    onChange={handleWithdrawChange}
                                    value={withdraw}
                                    sx={{
                                      "& fieldset": {
                                        border: "0px solid #d3d1d1 !important",
                                      },
                                    }}
                                  />
                                </div>
                                <div
                                  className="display-2 sel-new cursor mt-20"
                                  onClick={() => {
                                    handleOpenNetwork();
                                  }}
                                >
                                  {selectedNetwork ? (
                                    <div className="display-1  ">
                                      <div>
                                        {selectedNetwork?.Network_symbol}
                                      </div>
                                    </div>
                                  ) : (
                                    selectNetworkNew
                                  )}

                                  <KeyboardArrowDownIcon
                                    sx={{ fill: "var(--clr-font)" }}
                                  />
                                </div>
                                {/* <FormControl fullWidth>
                                  <Select
                                    className="bord-li"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={network}
                                    onChange={handleChangeNetwork}
                                    sx={{
                                      "& .MuiInputBase-formControl": {
                                        border: "0px",
                                      },
                                      "& fieldset": {
                                        border: "0px solid #d3d1d1 !important",
                                      },
                                    }}
                                  >
                                    <MenuItem
                                      value={"10"}
                                      onClick={() => setSelectedNetwork("")}
                                    >
                                      Select network
                                    </MenuItem>
                                    {selectedAsset?.networks?.length > 0 &&
                                      selectedAsset?.networks?.map(
                                        (rows1, index) => {
                                          return (
                                            <MenuItem
                                              value={rows1?.Network_symbol}
                                              key={index}
                                              onClick={() =>
                                                setSelectedNetwork(rows1)
                                              }
                                            >
                                              {rows1?.Network_symbol}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                  </Select>
                                </FormControl> */}
                              </div>

                              {/* <Box sx={{ mb: 2 }}>
                                <Button
                                  variant="contained"
                                  onClick={handleNext}
                                  sx={{ mt: 1, mr: 1 }}
                                  className="continue-btn"
                                >
                                  {index === steps.length - 1 ? 'Finish' : 'Continue'}
                                  Continue
                                </Button>
                                <Button
                                    disabled={index === 0}
                                  onClick={handleBack}
                                  sx={{ mt: 1, mr: 1 }}
                                  className="back-btn"
                                >
                                  Back
                                </Button>
                              </Box> */}
                            </StepContent>
                          </Step>
                          {/* <Step className="deposit-steps">
                            <StepLabel>
                              <h3>Withdraw To</h3>
                            </StepLabel>
                            <StepContent TransitionProps={{ in: true }}>
                              <Box sx={{ mb: 2 }}>
                                <Button
                                  variant="contained"
                                  onClick={handleNext}
                                  sx={{ mt: 1, mr: 1 }}
                                  className="continue-btn"
                                >
                                  Continue
                                </Button>
                                <Button
                                  onClick={handleBack}
                                  sx={{ mt: 1, mr: 1 }}
                                  className="back-btn"
                                >
                                  Back
                                </Button>
                              </Box>
                            </StepContent>
                          </Step> */}
                          <Step className="deposit-steps">
                            <StepLabel>
                              <h3>Withdraw Amount </h3>
                            </StepLabel>
                            <StepContent
                              TransitionProps={{
                                in: activeStep === 2 ? true : false,
                              }}
                            >
                              <div className="deposit-select widthdraw-aa">
                                <TextField
                                  className="bord-li"
                                  placeholder="Enter withdraw amount"
                                  fullWidth
                                  onChange={(e) =>
                                    setWithdrawAmount(e.target.value)
                                  }
                                  type="number"
                                  value={withdrawAmount}
                                  sx={{
                                    "& fieldset": {
                                      border: "0px solid #d3d1d1 !important",
                                    },
                                  }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment
                                        position="end"
                                        sx={{ color: "var(--hightlight-txt)" }}
                                      >
                                        <div
                                          className="org_txt cursor"
                                          style={{
                                            fontSize: "14px",
                                            cursor: "pointer",
                                          }}
                                          onClick={handleMaxClick}
                                        >
                                          {" "}
                                          MAX
                                        </div>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </div>

                              <div className="display-2 mt-30">
                                <p className="withdraw-amonunt-details">
                                  Fees{" "}
                                </p>
                                <p className="withdraw-amonunt-details">
                                  {selectedNetwork?.Fees}
                                </p>
                                <p className="withdraw-amonunt-details">
                                  Min Withdraw{" "}
                                </p>
                                <p className="withdraw-amonunt-details">
                                  {selectedAsset?.min_withdraw || 0}
                                </p>

                                <p className="withdraw-amonunt-details">
                                  Max Withdraw{" "}
                                </p>
                                <p className="withdraw-amonunt-details">
                                  {selectedAsset?.max_withdraw || 0}
                                </p>
                              </div>

                              <div className="display-2 mt-30">
                                <p className="withdraw-amonunt-details">
                                  Available Balance{" "}
                                </p>
                                <p className="withdraw-amonunt-details">
                                  {wallet?.first?.funding_balance || 0}
                                </p>
                              </div>
                              {/* <div className="display-2 mt-20 mb-20">
                                <p className="withdraw-amonunt-details">Minimum <span>2.0000</span></p>
                                <p className="withdraw-amonunt-details"> Maximum   <span>30.0000</span></p>
                              </div> */}
                              <Divider />

                              <p className="highlight-text">
                                Note: Your crypto withdrawal will be settled
                                within 24 hours.
                              </p>
                              <div className="display-2 mt-20">
                                <div>
                                  <p
                                    style={{ fontWeight: "400" }}
                                    className="deposit-sub-title"
                                  >
                                    Receive Amount{" "}
                                  </p>
                                  <h3 className="sub-title">{`${withdrawAmount == ""
                                    ? 0
                                    : withdrawAmount >
                                      wallet?.first?.funding_balance
                                      ? 0
                                      : withdrawAmount >
                                        wallet?.first?.funding_balance
                                        ? 0
                                        : withdrawAmount -
                                          Number(selectedNetwork?.Fees) >
                                          0
                                          ? decimal(
                                            withdrawAmount -
                                            Number(selectedNetwork?.Fees)
                                          )
                                          : 0
                                    } ${coin}`}</h3>
                                  {/* <p style={{ fontWeight: "400" }} className="deposit-sub-title">
                                    Network Fee 0.03 USDT
                                  </p> */}
                                </div>
                                <div>
                                  <Button
                                    onClick={() => {
                                      if (
                                        withdrawAmount <
                                        selectedAsset?.min_withdraw
                                      ) {
                                        return toast.error(
                                          `Minimum withdraw amount is ${selectedAsset?.min_withdraw} ${coin}`
                                        );
                                      } else if (
                                        withdrawAmount >
                                        selectedAsset?.max_withdraw
                                      ) {
                                        return toast.error(
                                          `Maximum withdraw amount is ${selectedAsset?.max_withdraw} ${coin}`
                                        );
                                      }
                                      if (
                                        withdrawAmount -
                                        Number(selectedNetwork?.Fees) ==
                                        0
                                      ) {
                                        return toast.error(
                                          `You Dont have enough balance to withdraw ${withdrawAmount} ${coin}`
                                        );
                                      }
                                      handleOpen1();
                                    }}
                                    className="org_btn"
                                    disabled={
                                      wallet?.first?.funding_balance <= 0 ||
                                      withdrawAmount >
                                      wallet?.first?.funding_balance ||
                                      wallet?.first == null ||
                                      withdrawAmount <= 0
                                    }
                                    sx={{ borderRadius: "8px" }}
                                  >
                                    Withdraw
                                  </Button>
                                </div>
                              </div>
                              {/* <Box sx={{ mb: 2 }}>
                                <Button
                                  //   disabled={index === 0}
                                  onClick={handleBack}
                                  sx={{ mt: 1, mr: 1 }}
                                  className="back-btn"
                                >
                                  Back
                                </Button>
                              </Box> */}
                            </StepContent>
                          </Step>
                        </Stepper>
                      </div>
                    </Grid>
                  </Grid>
                </CustomTabPanel>
              </Box>
            </div>
          </div>
          <div className="deposit-bottom">
            <div>
              <h3 className="subtitle">Recent Withdrawals</h3>
              <TableContainer
                sx={{
                  margin: "20px 0",
                  borderRadius: "5px",
                  border: "1px solid var(--brd-new)",
                }}
              >
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="deposit-table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Date & Time</TableCell>
                      <TableCell align="center">Currency</TableCell>
                      <TableCell align="center">Asset Type</TableCell>
                      <TableCell align="center">Amount</TableCell>
                      <TableCell align="center">Fees</TableCell>
                      <TableCell align="center">Address</TableCell>
                      <TableCell align="center">Transaction ID</TableCell>
                      <TableCell align="center">Status</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {history?.docs?.length > 0 ? (
                      paginatedData?.map((row, i) => (
                        <TableRow className="tr_row">
                          <TableCell>
                            {" "}
                            {getTimeFormat(row.createdAt)}{" "}
                          </TableCell>
                          <TableCell>
                            <div className="d-flex align-items-center justi-center gap-10">
                              <div>
                                <img
                                  src={row.currency}
                                  alt={row.currencyName}
                                  className="coin-img"
                                />
                              </div>
                              <div>{row.Coinname}</div>
                            </div>
                          </TableCell>
                          <TableCell align="center">Funding Asset</TableCell>
                          <TableCell align="center">
                            {decimal(row.Amount)}
                          </TableCell>
                          <TableCell align="center">{row.Fees}</TableCell>
                          <TableCell align="center">{row.Address}</TableCell>
                          <TableCell align="center">{row.txId}</TableCell>
                          <TableCell
                            align="center"
                            className={
                              row.Status?.toLowerCase() === "cancelled"
                                ? "red"
                                : row.Status?.toLowerCase() === "pending"
                                  ? "yellow"
                                  : "green"
                            }
                          >
                            {row.Status}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow className="tr_row text-center">
                        <TableCell align="center" colSpan={8}>
                          <img src={noodata} alt="nodata" />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component="div"
                  count={filteredData?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                // onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box class="boxstyle">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div className="otp_flx">
              <span className="otp">Confirm withdrawal </span>
              <svg
                onClick={handleClose1}
                className="cursor-pointer fill_dark_to_white"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9997 23.1673C9.89001 23.1673 7.82772 22.5417 6.0736 21.3697C4.31947 20.1976 2.9523 18.5317 2.14496 16.5826C1.33763 14.6335 1.12639 12.4888 1.53797 10.4197C1.94955 8.35056 2.96545 6.44994 4.45721 4.95818C5.94897 3.46642 7.84959 2.45052 9.91872 2.03895C11.9878 1.62737 14.1326 1.83861 16.0816 2.64594C18.0307 3.45328 19.6966 4.82045 20.8687 6.57457C22.0408 8.3287 22.6663 10.391 22.6663 12.5007C22.6663 15.3296 21.5425 18.0427 19.5422 20.0431C17.5418 22.0435 14.8287 23.1673 11.9997 23.1673ZM11.9997 3.16732C10.1537 3.16732 8.34922 3.71471 6.81436 4.74027C5.2795 5.76583 4.08322 7.2235 3.3768 8.92894C2.67039 10.6344 2.48555 12.511 2.84568 14.3215C3.20581 16.132 4.09473 17.795 5.40002 19.1003C6.70531 20.4056 8.36835 21.2945 10.1788 21.6547C11.9893 22.0148 13.8659 21.83 15.5714 21.1235C17.2768 20.4171 18.7345 19.2208 19.7601 17.686C20.7856 16.1511 21.333 14.3466 21.333 12.5007C21.333 11.275 21.0916 10.0613 20.6226 8.92894C20.1535 7.79657 19.466 6.76767 18.5993 5.90099C17.7327 5.03431 16.7038 4.34682 15.5714 3.87778C14.439 3.40874 13.2254 3.16732 11.9997 3.16732ZM12.8977 12.5007L15.1417 14.7473C15.2601 14.8664 15.3264 15.0277 15.326 15.1956C15.3256 15.3636 15.2584 15.5245 15.1393 15.643C15.0203 15.7615 14.859 15.8278 14.691 15.8273C14.5231 15.8269 14.3621 15.7597 14.2437 15.6407L11.9997 13.4007L9.75568 15.6407C9.69702 15.6996 9.62733 15.7465 9.55057 15.7785C9.47381 15.8105 9.3915 15.8271 9.30833 15.8273C9.22516 15.8275 9.14276 15.8114 9.06584 15.7797C8.98892 15.7481 8.91898 15.7016 8.86001 15.643C8.80105 15.5843 8.75422 15.5146 8.72219 15.4379C8.69016 15.3611 8.67356 15.2788 8.67335 15.1956C8.67291 15.0277 8.73922 14.8664 8.85768 14.7473L11.1017 12.5007L8.85701 10.254C8.79808 10.1955 8.7513 10.1259 8.71938 10.0492C8.68745 9.97258 8.67102 9.89036 8.67102 9.80732C8.67102 9.72428 8.68745 9.64206 8.71938 9.5654C8.7513 9.48874 8.79808 9.41916 8.85701 9.36066C8.9764 9.24215 9.13779 9.17564 9.30601 9.17564C9.47423 9.17564 9.63563 9.24215 9.75501 9.36066L11.9997 11.6007L14.2443 9.36066C14.3637 9.24215 14.5251 9.17564 14.6933 9.17564C14.8616 9.17564 15.023 9.24215 15.1423 9.36066C15.2013 9.41916 15.2481 9.48874 15.28 9.5654C15.3119 9.64206 15.3283 9.72428 15.3283 9.80732C15.3283 9.89036 15.3119 9.97258 15.28 10.0492C15.2481 10.1259 15.2013 10.1955 15.1423 10.254L12.8977 12.5007Z"
                  fill="#1E2329"
                />
              </svg>
            </div>
          </Typography>
          <br />

          <div>
            <div className="display-2 mb-20">
              <div>Address</div>
              <div>{`${withdraw.slice(0, 10)}....${withdraw.slice(-5)}`}</div>
              {/* <div>{withdraw}</div> */}
            </div>
            <div className="display-2 mb-20">
              <div>Network</div>
              <div style={{ fontWeight: "600" }}>
                {selectedNetwork?.Network_symbol}
              </div>
            </div>
            <div className="display-2 mb-20">
              <div>Amount</div>
              <div style={{ fontWeight: "600" }}>
                Receive{" "}
                {decimal(withdrawAmount - Number(selectedNetwork?.Fees))} {coin}
              </div>
            </div>

            <div className="display-2 mb-20">
              <div>Fees</div>
              <div style={{ fontWeight: "600" }}>
                {Number(selectedNetwork?.Fees)} {coin}
              </div>
            </div>
            <div className="display-2 mb-20">
              <div>Source</div>
              <div style={{ fontWeight: "600" }}>Funding wallet </div>
            </div>
            <div className="bd_rline"></div>
            <p>Ensure that the address is correct and on the same network.</p>
            <div className="mb-20" style={{ fontWeight: "600" }}>
              Transaction cannot be cancelled
            </div>
            <Button
              onClick={handleOpen2}
              className="org_btn mt-20"
              style={{ width: "100%", borderRadius: "8px", padding: "10px" }}
            >
              Withdraw
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box class="boxstyle">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
          ></Typography>
          <br />

          <div>
            <div className="display-3">
              <div className="prc_img">
                <img src={processing} alt="img" />
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <h3 style={{ marginBottom: "0" }}>Payment Processing</h3>
              <h1 style={{ marginTop: "10px" }}>100.00 BNB</h1>
            </div>
            <div className="display-2 mb-20 flex-wrap">
              <div>Send Mode</div>
              <div>PAY ID</div>
            </div>
            <div className="display-2 mb-20 flex-wrap">
              <div>Send to </div>
              <div style={{ fontWeight: "600" }}>BNB Smart Chain (BEP20)</div>
            </div>
            <div className="display-2 mb-20 flex-wrap">
              <div>Send from</div>
              <div style={{ fontWeight: "600" }}>Spot Wallet</div>
            </div>
            <div className="display-2 mb-20 flex-wrap">
              <div>Note</div>
              <div style={{ fontWeight: "600" }}>Spot wallet </div>
            </div>
            <Button
              onClick={handleClose2}
              className="org_btn mt-20"
              style={{ width: "100%", borderRadius: "8px", padding: "10px" }}
            >
              ok
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={open3}
        onClose={handleClose3}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box class="boxstyle">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
          ></Typography>
          <br />

          <div>
            <div className="display-3">
              <div className="prc_img" style={{ background: "transparent" }}>
                <img src={tic_mark} alt="img" />
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <h3 style={{ marginBottom: "0" }}>Recipient Amount</h3>
              <h1 style={{ marginTop: "10px" }}>{`${decimal(
                withdrawAmount - Number(selectedNetwork?.Fees)
              )} ${coin}`}</h1>
            </div>
            {/* <p style={{ color: "#707a8a" }}>
              You will receive an email once the withdrawal transaction is
              completed,.
            </p> */}
            <div className="display-2 mb-20 flex-wrap">
              <div>Address</div>
              <div>{`${withdraw.slice(0, 10)}....${withdraw.slice(-5)}`}</div>
            </div>
            <div className="display-2 mb-20 flex-wrap">
              <div>Network </div>
              <div style={{ fontWeight: "600" }}>
                {selectedNetwork?.Network_symbol}
              </div>
            </div>
            {/* <div className="display-2 mb-20 flex-wrap">
              <div>Memo</div>
              <div style={{ fontWeight: "600" }}>Funding Wallet</div>
            </div> */}
            <div className="display-2 mb-20 flex-wrap">
              <div>Amount</div>
              <div style={{ fontWeight: "600" }}>
                Receive{" "}
                {`${decimal(
                  withdrawAmount - Number(selectedNetwork?.Fees)
                )} ${coin}`}
              </div>
            </div>
            <div className="display-2 mb-20">
              <div>Fees</div>
              <div style={{ fontWeight: "600" }}>
                {Number(selectedNetwork?.Fees)} {coin}
              </div>
            </div>
            <div className="display-2 mb-20 flex-wrap">
              <div>Source</div>
              <div style={{ fontWeight: "600" }}>Funding wallet</div>
            </div>
            <Button
              onClick={handleClose3}
              className="org_btn mt-20"
              style={{ width: "100%", borderRadius: "8px", padding: "10px" }}
            >
              ok
            </Button>
          </div>
        </Box>
      </Modal>
      <Footernew />
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-10">
            <div className="coins">Coin</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleClose}
            />
          </div>
          <div className="p-10">
            <div class="inputBox_container">
              <svg
                class="search_icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                alt="search icon"
              >
                <path d="M46.599 46.599a4.498 4.498 0 0 1-6.363 0l-7.941-7.941C29.028 40.749 25.167 42 21 42 9.402 42 0 32.598 0 21S9.402 0 21 0s21 9.402 21 21c0 4.167-1.251 8.028-3.342 11.295l7.941 7.941a4.498 4.498 0 0 1 0 6.363zM21 6C12.717 6 6 12.714 6 21s6.717 15 15 15c8.286 0 15-6.714 15-15S29.286 6 21 6z"></path>
              </svg>
              <input
                class="inputBox"
                id="inputBox"
                type="text"
                placeholder="Search For Coins"
                onChange={(e) => setSymbolSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="top p-10">
            Top
            <div className=" display-1 mt-10">
              {assetsList?.slice(0, 3)?.map((row, i) => (
                <div
                  className="deposits-coins v2 display-3 cursor"
                  key={i}
                  onClick={() => {
                    setCoin(row?.symbol);
                    setSelectedAsset(row);
                    // handleChangeCoin()
                    handleClose();
                    setWithdrawAmount("");
                    setWithdraw("");
                  }}
                >
                  {/* <div className="d-flex drop-img">
                          <img src={row?.image} alt="img" width={"20px !important"} />
                        </div> */}
                  <div>{row?.symbol}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="select-model-data">
            {assetsList?.filter(
              (row) =>
                symbolSearch.trim() === "" ||
                row.symbol
                  .toLowerCase()
                  .includes(symbolSearch.trim().toLowerCase())
            )?.length > 0 ? (
              assetsList
                ?.filter(
                  (row) =>
                    symbolSearch.trim() === "" ||
                    row.symbol
                      .toLowerCase()
                      .includes(symbolSearch.trim().toLowerCase())
                )
                ?.map((row, index) => (
                  <div
                    key={index}
                    value={row?.symbol}
                    onClick={() => {
                      setSelectedAsset(row);
                      setActiveStep(1);
                      setSelectedNetwork("");
                      setCoin(row?.symbol);
                      handleClose();
                      setWithdrawAmount("");
                      setWithdraw("");
                    }}
                    className="cursor"
                  >
                    <div className="display-1 p-10">
                      <div className="d-flex drop-img">
                        <img alt={row?.symbol} src={row?.image} />
                      </div>
                      <div>{row?.symbol}</div>
                    </div>
                  </div>
                ))
            ) : (
              <div
                className="p-10  display-3"
                style={{ color: "#888", height: "100%" }}
              >
                No data found
              </div>
            )}
          </div>
        </Box>
      </Modal>
      <Modal
        open={openNetwork}
        // onClose={handleCloseNetwork}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Network</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseNetwork}
            />
          </div>
          <div className="p-10 select-model-network">
            {selectedAsset?.networks?.map((net, idx) => (
              <div
                key={idx}
                value={net?.Network_symbol}
                onClick={() => {
                  if (withdraw === "") {
                    toast.error("Please Enter Withdraw Address");
                    handleCloseNetwork();
                  } else {
                    setSelectedNetwork(net);
                    handleCloseNetwork();
                    setActiveStep(2);
                    setWithdrawAmount("");
                    // handleNext();
                  }
                }}
                className="p-10 cursor"
              >
                {net?.Network_symbol}
              </div>
            ))}
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Withdraw;
